import script from "./TwoFactorInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoFactorInput.vue?vue&type=script&setup=true&lang=js"

import "./TwoFactorInput.vue?vue&type=style&index=0&id=9b36d18c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b36d18c"]])

export default __exports__